import React from 'react';
import useIsMobile from 'tradera-hooks/use-is-mobile';
import useIsDesktop from 'tradera-hooks/use-is-desktop';
import FavouriteSellerCard from './favourite-seller-card';
import 'tradera-components/item-card/layout.scss';
import './favourite-sellers.scss';

export const FavouriteSellerCardsGrid = ({
    className = '',
    sellers: allSellers,
    isSuggestion = false
}) => {
    const isMobile = useIsMobile();
    const isDesktop = useIsDesktop();

    if (!allSellers?.length) {
        return null;
    }

    const sellers = isMobile
        ? allSellers
        : allSellers?.slice(0, isDesktop ? 4 : 3);

    return (
        <div
            className={`favourite-seller-cards-grid ${className} ${
                isMobile
                    ? 'overflow-x-auto pl-2'
                    : 'overflow-hidden px-3 mr-n2 mr-lg-n4 px-xl-1'
            }`}>
            {sellers?.map(seller => (
                <div
                    className="favourite-seller-card-container pr-2 pr-lg-4 mb-2"
                    key={seller.sellerId}>
                    <FavouriteSellerCard
                        {...seller}
                        isSuggestion={isSuggestion}
                    />
                </div>
            ))}
        </div>
    );
};
